/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Records_Cycling_SubtitleInputs */

const en_ui_records_cycling_subtitle = /** @type {(inputs: Ui_Records_Cycling_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Power & distance records`)
};

const de_ui_records_cycling_subtitle = /** @type {(inputs: Ui_Records_Cycling_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungs- & Distanzrekorde`)
};

/**
* | output |
* | --- |
* | "Power & distance records" |
*
* @param {Ui_Records_Cycling_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_records_cycling_subtitle = /** @type {((inputs?: Ui_Records_Cycling_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Records_Cycling_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_records_cycling_subtitle(inputs)
	return de_ui_records_cycling_subtitle(inputs)
});